<template>
  <div class="mt-3 p-2">
    <b-container fluid class="mb-2">
      <b-row class="mb-2">
        <b-col md="6">
          <h5 class="text-uppercase heading">Farms</h5>
        </b-col>
        <b-col md="6" class="text-right">
          <project-create @project-create="projectListReload"></project-create>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col md="2">
          <!-- Select User Per Page  -->
          <b-form-select v-model="item_per_page" @change="changeItemNumber">
            <b-form-select-option value="10">10</b-form-select-option>
            <b-form-select-option value="50">50</b-form-select-option>
            <b-form-select-option value="100">100</b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col md="9">
          <!-- Filter -->
          <b-form-group label="" label-for="filter-input" class="mb-0">
            <b-input-group>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="1" class="d-flex justify-content-end">
          <b-button variant="success" @click="downloadCSV">
            <i class="fa fa-download" aria-hidden="true"></i>
          </b-button>
        </b-col>
      </b-row>

      <b-table
        class="dataTable rounded-left"
        :outlined="true"
        :items="items"
        :fields="fields"
        :filter="filter"
        @filtered="filtered"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        head-variant="none"
        table-variant="none"
        :busy="isBusy"
      >
        <template #cell(#)="data">
          <span v-if="currentPage == 1">{{ data.index + 1 }}</span>
          <span v-else>{{
            (currentPage - 1) * item_per_page + (data.index + 1)
          }}</span>
        </template>
        <template #cell(image)="row">
          <img
            :src="row.item.image"
            class="rounded"
            width="50px"
            height="50px"
          />
        </template>
        <template #cell(actions)="row">
          <router-link :to="'/projects/' + row.item._id"
            ><i class="fas fa-eye view-icon" aria-hidden="true"></i>
          </router-link>
          <router-link :to="'/projects/' + row.item._id + '/edit'"
            ><i class="fas fa-edit edit-icon" aria-hidden="true"></i>
          </router-link>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-center mt-4">
        <b-pagination
          pills
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </b-container>
  </div>
</template>

<script>
import projectCreate from '@/components/projects/create';
export default {
  name: 'Users',
  data() {
    return {
      item_per_page: 10,
      perPage: 10,
      currentPage: 1,
      sortBy: 'name',
      sortDesc: false,
      filter: null,
      isBusy: false,
      fields: [
        '#',
        'image',

        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'code',
          label: 'Code',
          sortable: true,
        },
        'actions',
      ],
      items: [],
      downloadItems: [],
    };
  },
  components: {
    projectCreate,
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    filtered(filteredItems) {
      this.downloadItems = filteredItems;
    },

    projectListReload() {
      this.fetchData();
    },

    changeItemNumber() {
      this.perPage = this.item_per_page;
    },
    fetchData() {
      this.isBusy = true;
      window.axios.get('project').then((resp) => {
        console.log(resp.data);
        this.items = resp.data.data;
        this.downloadItems = this.items;
        this.isBusy = false;
      });
    },

    downloadCSV() {
      let csv = '\ufeff' + 'NAME,CODE\n';
      this.downloadItems.forEach((el) => {
        var line = el['name'] + ',' + el['code'] + '\n';
        csv += line;
      });
      var blob = new Blob([csv], { type: 'csv/plain' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Farms.csv';
      link.click();
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 3.5%;
  margin-top: 5px;
  margin-left: 4px;
  margin-bottom: 5px;
  color: #454545;
}

.view-icon {
  color: #1da040;
  height: 20px;
  width: 30px;
}

.edit-icon {
  color: #68561d;
  height: 20px;
  width: 30px;
  margin-left: 10px;
}

/deep/ .dataTable thead {
  background-color: #dcffd9;
  height: 64px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 3.5%;
  font-family: 'Poppins', sans-serif;
  padding-top: 14px;
  padding-bottom: 14px;
  color: #303030;
}

/deep/ .dataTable {
  text-align: center;
  margin-bottom: 21.5px;
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

/deep/ .dataTable tr td {
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  letter-spacing: 3.5%;
  line-height: 25.5px;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
